import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, NumberDecoder, StringDecoder } from '@simonbackx/simple-encoding';
export class GraphData extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.label = '';
        this.values = [];
    }
}
__decorate([
    field({ decoder: StringDecoder })
], GraphData.prototype, "label", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(NumberDecoder) })
], GraphData.prototype, "values", void 0);
export class Graph extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.labels = [];
        this.data = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], Graph.prototype, "labels", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(GraphData) })
], Graph.prototype, "data", void 0);
//# sourceMappingURL=Graph.js.map